import React, { PureComponent } from 'react';

import { View, WebView, Platform, TouchableOpacity } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import { DatePicker, Utils } from '@dbk/ui-datepicker';
import Modal from '@dbk/ui-modal';
import moment from 'moment';
import 'moment/min/locales';
import Text from '@dbk/ui-text';
import Button from '@dbk/ui-buttons';
import InverseProvider from '@dbk/ui-inverse';
import { addDays, addMonths, ymd } from '../../../../src/utils/date';

class DateRangeSelector extends PureComponent {
    constructor(props) {
        super(props);
        const { maturities: { fromDate, toDate } } = props;

        const languageCode = this.props.auth.langCode;
        Utils.configLocale(languageCode, {
            week: {
                dow: 1, // Monday is the first day of the week.
                // dow: 0, // Sunday is the first day of the week.
            },
        })

        this.state = {
            values: {
                from: fromDate ? moment(ymd(fromDate)) : null,
                to: toDate ? moment(ymd(toDate)) : null
            }
        }

    }

    componentWillUnmount() {
        this.props.maturities.setShowDateRange(false);
    }

    componentDidUpdate(){
        if (this.props.reports.closeDatePicker === true && this.datepickerRef && this.datepickerRef.datepicker && this.datepickerRef.datepicker.state && this.datepickerRef.datepicker.state.isOpen ) {
          this.onCancel();
        }
      }

    onCancel = () => {
        this.datepickerRef.datepicker.closeCalendar();
        this.props.setDatePickerClose(false);
    }

    hideDateRangeModal = () => {
        this.datepickerRef.datepicker.closeCalendar();
    }


    // onDayClick = (selectionStart) => {
    //     const value = Utils.addDayToRange(selectionStart, this.state.dateRange);
    //     this.setState({
    //         dateRange: value
    //     });
    // }

    // onDayClick = (day) => {
    //     const range = Utils.addDayToRange(day, { ...this.state.dateRange });
    //     this.setState({
    //         dateRange: {
    //             ...Utils.updateRangeWithReset(this.state.dateRange, range)
    //         }
    //     })
    // }

    onChangeRange = (range) => {
        this.setState({
            values: {
                ...Utils.updateRangeWithReset(this.state.values, range)
            }
        });
    };

    onDateApply = () => {
        const { values: { from, to } } = this.state;
        this.props.maturities.onCalendarDone({
            fromDate: from ? moment(from).format('YYYY-MM-DD') : null,
            toDate: to ? moment(to).format('YYYY-MM-DD') : null
        });
        this.datepickerRef.datepicker.closeCalendar();
    }

    customFooter = () => {
        const { i18n: { messages } } = this.props;
        const { values: { from, to } } = this.state;
        return <InverseProvider inverse className="customFooterParent">
            <div className="customFooterBody">
                <Text className="customFooterToday">{messages['app.calendar.today']}{moment(from).format('DD-MMM-YYYY')}</Text>
            </div>
            <div className="datepicker-footer-btn">
                <Button tertiary
                    onClick={() => this.hideDateRangeModal()}
                >{messages['app.profile.changeLanguage.cancelText']}</Button>

                <Button
                    onClick={() => this.onDateApply()}
                    disabled={!(from && to)}
                >{messages['app.calendar.apply']}</Button>
            </div>
        </InverseProvider>
    }


    render() {
        const { values } = this.state;
        const { i18n: { messages }, portfolio: { overallMarketValue: { asOfDate } } } = this.props;
        return (
            <div>
                { !this.props.logoutPopup.isVisible && <DatePicker
                    ref={(ref) => this.datepickerRef = ref}
                    showOutsideMonthDays={false}
                    enableYearNavigation
                    enableRangeSelection
                    onChange={this.onChangeRange}
                    value={values}
                    startDate={moment(ymd(asOfDate))}
                    endDate={moment(ymd(asOfDate)).add(1, 'year')}
                    selectionStart={values.from}
                    selectionEnd={values.to}
                    disableWeekendDays
                    inputDateFormat={'DD MMM YYYY'}
                    // disablePastDays
                    renderFooter={() => this.customFooter()} />}
            </div>

        )
    }
}

export default createContainer({
    $queries: {
        maturities: {
            fromDate: true,
            toDate: true,
            onCalendarDone: { $call: 'onCalendarDone' },
            showDateRange: true,
            setShowDateRange: { $set: 'showDateRange' },
        },
        reports:{
            closeDatePicker:true
        },
        setDatePickerClose: {
            $set: 'reports.closeDatePicker'
          },
        i18n: {
            messages: true,
        },
        auth: {
            langCode: true,
        },
        portfolio:{
            overallMarketValue:{
              asOfDate: true,
            },
        },
        logoutPopup: {isVisible : true},
    },

})(DateRangeSelector);
